import React from "react";

const BdAddress = () => {
  return (
    <div className="border p-8 bg-blue-100 md:w-2/3 mx-auto mt-6">
      <div className="md:flex justify-between items-center">
        <div>
          <h1>Street: 17/4 Dhanmondi.</h1>
          <h1>City: Dhaka</h1>
          <h1>Phone: +8801622222456</h1>
          <h1>Email: contact.bd@cc.com</h1>
        </div>
        <div>
          <h1 className="text-2xl mt-3">BANGLADESH OFFICE</h1>
        </div>
      </div>
    </div>
  );
};

export default BdAddress;
